import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c166ad10&scoped=true"
import script from "./js/index.js?vue&type=script&lang=js&external"
export * from "./js/index.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=c166ad10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c166ad10",
  null
  
)

export default component.exports